import React from 'react'

function checkIcon() {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#454545">
          <path d="M27.048 14.217l-11.19 11.19-1.6-1.598L25.45 12.617z" />
          <path d="M17.456 23.81l-1.598 1.598-4.797-4.797 1.6-1.598z" />
        </g>
        <circle stroke="#555A5E" cx="19" cy="19" r="17" />
      </g>
    </svg>
  )
}

export default checkIcon



// WEBPACK FOOTER //
// ./src/icons/checkIcon.js